import { Link } from 'react-router-dom';
import Pagination from '../../../shared/components/Pagination';
import { formatDate } from '../../../utils';

const SearchNews = ({ list, pages }) => {
    return (
        <div id="notices-news">
            <div className="top-table">
                <div className="count-results">공지/소식</div>
                <Link to="/pahaf010" className="more-results light-blue">
                    공지/소식 보기 &gt;
                </Link>
            </div>
            <ul className="table content-table">
                {list.map((item, index) => {
                    const statusClass = item?.gubun === '01' ? 'blue' : 'green';
                    const statusText = item?.gubun === '01' ? '공지' : '정보';
                    const formattedDate = formatDate(item?.addDate);

                    return (
                        <li className="flex wrap-item" key={`news-${index}`}>
                            <div className="flex wrap-left">
                                <div className={`status ${statusClass}`}>{statusText}</div>
                                <Link to={`/pahaf020-${item?.seq}`} className="item-title">
                                    {item?.title}
                                </Link>
                            </div>
                            <div className="date">{formattedDate}</div>
                        </li>
                    );
                })}
            </ul>
            <Pagination pages={pages} params="pageNews" />
        </div>
    );
};
export default SearchNews;
